type WarehouseBadgeProps = {
  city: string
  className?: string
}

export default function WarehouseBadge({ city, className = '' }: WarehouseBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold tracking-[0.02em] text-slate-700 ${className}`.trim()}
    >
      {city}
    </span>
  )
}
